export interface IWarehouseAdminStockProductInfoData {
    id: number;
    name: string;
    description?: string|null;
}

export interface IWarehouseAdminStockProductData {
    product: IWarehouseAdminStockProductInfoData;
    min_stock: number|null;
    max_stock: number|null;
    last_stock_count: number;
    last_stock_count_on: string|null;
    last_stock_count_by: string|null;
    rack: string|null;
    layer: string|null;
}

export default class WarehouseAdminStockProductData {
    public product: {
        id: number;
        name: string;
        description: string|null;
    };

    public min_stock: number|null;
    public max_stock: number|null;
    public last_stock_count: number;
    public last_stock_count_on: string|null;
    public last_stock_count_by: string|null;
    public rack: string|null;
    public layer: string|null;

    constructor(data: IWarehouseAdminStockProductData) {
        this.product = {
            id: Number(data.product.id),
            name: data.product.name,
            description: data.product.description ?? null
        };

        this.min_stock = data.min_stock === null
            ? null
            : Number(data.min_stock);

        this.max_stock = data.max_stock === null
            ? null
            : Number(data.max_stock);

        this.last_stock_count = Number(data.last_stock_count ?? 0);
        this.last_stock_count_on = data.last_stock_count_on ?? null;
        this.last_stock_count_by = data.last_stock_count_by ?? null;
        this.rack = data.rack ?? null;
        this.layer = data.layer ?? null;
    }
}